// src/components/LightboxCarousel.jsx  (YENİ)
import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";

export default function LightboxCarousel({ open, onClose, items = [], startIndex = 0 }) {
  const [idx, setIdx] = useState(startIndex);
  const wrap = useRef(null);
  const touch = useRef({ x: 0, y: 0 });

  useEffect(() => { if (open) setIdx(startIndex); }, [open, startIndex]);

  const prev = useCallback(() => setIdx((i) => (i - 1 + items.length) % items.length), [items.length]);
  const next = useCallback(() => setIdx((i) => (i + 1) % items.length), [items.length]);

  // Klavye: ← → Escape
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "ArrowLeft") prev();
      else if (e.key === "ArrowRight") next();
      else if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, prev, next, onClose]);

  // Swipe (mobil)
  const onTouchStart = (e) => { touch.current.x = e.touches[0].clientX; touch.current.y = e.touches[0].clientY; };
  const onTouchEnd = (e) => {
    const dx = e.changedTouches[0].clientX - touch.current.x;
    const dy = e.changedTouches[0].clientY - touch.current.y;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 48) {
      dx > 0 ? prev() : next();
    }
  };

  if (!open || !items.length) return null;
  const item = items[idx];

  return (
    <div className="lb-backdrop" role="dialog" aria-modal="true" onClick={onClose}>
      <div
        className="lb-content lb-carousel"
        onClick={(e) => e.stopPropagation()}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        ref={wrap}
      >
        <button className="lb-close" aria-label="Kapat" onClick={onClose}>×</button>

        <button className="lb-nav lb-prev" aria-label="Önceki" onClick={prev}>‹</button>
        <button className="lb-nav lb-next" aria-label="Sonraki" onClick={next}>›</button>

        <div className="lb-stage">
          {item.type === "video" ? (
            <video
              key={item.id} // slide değişiminde yeniden mount
              controls
              playsInline
              preload="metadata"
              poster={item.poster}
              className="lb-media"
            >
              <source src={item.src} type="video/mp4" />
              Tarayıcınız video etiketini desteklemiyor.
            </video>
          ) : (
            <img
              key={item.id}
              src={item.full || item.thumb}
              alt={item.alt || item.title}
              decoding="async"
              className="lb-media"
            />
          )}
        </div>

      </div>
    </div>
  );
}